import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'secondsLeft'
})
export class SecondsLeftPipe implements PipeTransform {

  transform(value: number): string {
    if(value <= 60) return `${value}s`;
    return `${(value/60).toFixed(0)}min`;
  }

}
